import FollowUpCost from './FollowUpCost';

export default class FollowUpCostConfiguration {

    constructor(kindergartenId, invoicingStart, category) {
        this.id = null;
        this.kindergarten = kindergartenId;
        this.invoicingStart = invoicingStart;
        this.category = category;
        this.deleted = false;
        this.followUpCosts = [];
    }
    static fromData(data) {
        if (!data) {
            return;
        }

        let followUpCostConfiguration = new FollowUpCostConfiguration();
        followUpCostConfiguration.id = data.id;
        followUpCostConfiguration.deleted = false;
        followUpCostConfiguration.kindergarten = data.kindergarten;
        followUpCostConfiguration.invoicingStart = data.invoicingStart;
        followUpCostConfiguration.category = data.category;
        followUpCostConfiguration.followUpCosts = data.followUpCosts.map(followUpCost => FollowUpCost.fromData(followUpCostConfiguration, followUpCost));

        return followUpCostConfiguration;
    }

    addFollowUpCost(startAge, cost, chargeLevel) {
        if (!this.followUpCosts) {
            this.followUpCosts = [];
        }
        this.followUpCosts.push(new FollowUpCost(this, startAge, cost, chargeLevel)); //todo: 'this' wieder raus ausm constructor?
    }

    sortFollowUpCosts() {
        this.followUpCosts.sort((a, b) => a.startAge - b.startAge);
    }

    serialize() {
        return {
            id: this.id,
            deleted: this.deleted,
            invoicingStart: this.invoicingStart,
            category: this.category,
            followUpCosts: this.followUpCosts.map(followUpCost => followUpCost.serialize())
        };
    }
}
